import { inject, provideEnvironmentInitializer } from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

export function withFlagsSelect() {
  return provideEnvironmentInitializer(() => {
    const controls = inject(CosFeatureFlagsToolbarControlsSet);
    controls.add(async () => {
      const { CosFeatureFlagsSelectComponent } = await import(
        './feature-flags-select.component'
      );
      return CosFeatureFlagsSelectComponent;
    });
  });
}
